import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/components/Landing";
import Assessment from "@/components/Assessment";
import Results from "@/components/Results";
import Admin from "@/components/Admin";
import ReportPage from "@/components/ReportPage";
import DetailedReport from "@/components/DetailedReport";
import PaymentSuccess from "@/components/PaymentSuccess";
import Professionals from "@/components/Professionals";
import { initAnalytics, trackPageView } from "@/analytics";

function RouteAnalytics() {
  const loc = useLocation();
  useEffect(() => { trackPageView(loc.pathname + loc.search); }, [loc.pathname, loc.search]);
  return null;
}

export const LangContext = createContext({ lang: "en", setLang: () => {} });
export const useLang = () => useContext(LangContext);

export const MatchContext = createContext({});
export const useMatch = () => useContext(MatchContext);

function App() {
  const [lang, setLang] = useState("en");
  const [matchData, setMatchData] = useState(null);
  const [answers, setAnswers] = useState(null);

  useEffect(() => { initAnalytics(); }, []);

  return (
    <div className="App">
      <LangContext.Provider value={{ lang, setLang }}>
        <MatchContext.Provider value={{ matchData, setMatchData, answers, setAnswers }}>
          <BrowserRouter>
            <RouteAnalytics />
            <Navbar />
            <Routes>
              <Route path="/" element={<Landing />} />
              {/* Instagram / social entry point into the funnel */}
              <Route path="/start" element={<Navigate to="/assessment" replace />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/results" element={<Results />} />
              <Route path="/onematch/report/:token" element={<ReportPage />} />
              <Route path="/onematch/report/:token/detailed" element={<DetailedReport />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<Admin />} />
              {/* ONE MATCH for Professionals (B2B) — additive, does not affect the consumer flow */}
              <Route path="/professionals" element={<Professionals view="signup" />} />
              <Route path="/professionals/onboarding" element={<Professionals view="onboarding" />} />
              <Route path="/professionals/dashboard" element={<Professionals view="dashboard" />} />
              <Route path="/professionals/billing" element={<Professionals view="billing" />} />
            </Routes>
            <Footer />
            <Toaster position="top-center" />
          </BrowserRouter>
        </MatchContext.Provider>
      </LangContext.Provider>
    </div>
  );
}

export default App;
